import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "./ParticularCourse.scss";
import DashDocPreview from "./DashDocPreview";
import { ImageLink } from "../../constants";
import { useNavigate } from "react-router-dom";
import CourseCardWithModal from "../../Pages/course/CourseCardWithModal";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
const DashSpStudyNotes = ({ Link, course, id }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [numPages, setNumPages] = useState(null);
  const isPaid = false;
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const courseWithType = {
    ...course,
    tempCourse: {
      courseType: "Special Study Notes",
      coursePrice: Link?.price,
      courseFilePath: Link?.filePath,
      courseTypeId: Link?._id,
    },
  };

  const toggleModal = () => setModalOpen(!modalOpen);
  return (
    <div className="course-study-note">
      {Link?.filePath ? (
        <>
          <p className="page-count">Preview 1 out of 20 Pages</p>
          <div className="row">
            <div className="col-lg-12">
              <div className="pdf-preview-container">
                {isPaid ? (
                  <div className="pdf-scrollable">
                    <Document
                      file={ImageLink(Link.filePath)}
                      onLoadSuccess={onDocumentLoadSuccess}
                    >
                      {Array.from(new Array(numPages), (el, index) => (
                        <Page
                          key={`page_${index + 1}`}
                          pageNumber={index + 1}
                        />
                      ))}
                    </Document>
                  </div>
                ) : (
                  <div className="pdf-preview">
                    <Document
                      file={ImageLink(Link.filePath)}
                      onLoadSuccess={onDocumentLoadSuccess}
                    >
                      <div className="pdf-page-wrapper">
                        <Page pageNumber={1} />
                      </div>

                      <div className="pdf-page-wrapper">
                        <div className="blurred">
                          <Page pageNumber={2} />
                        </div>
                        <div className="locked-pdf-div">
                          <div className="locked-pdf-div-content">
                            <div className="locked-pdf-div-content-flex">
                              <div className="locked-pdf-price">
                                Get Access - ${Link?.price}
                              </div>
                              <button
                                type="submit"
                                className="my-1 btn buy-locked"
                                onClick={toggleModal}
                              >
                                View Full Document
                              </button>
                              <div>
                                <ul className="locked-pdf-div-content-list">
                                  <li>Lifetime Access</li>
                                  <li>No Hidden Charges</li>
                                </ul>
                              </div>
                            </div>

                            <div className="locked-pdf-div-content-bottom">
                              <p>🎓 Prepared by Former Alumni</p>
                              <p>✅ 100% Satisfaction Guarantee</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Document>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      ) : (
        <DashDocPreview
          courseData={courseWithType}
          id={id}
          toggleModal={toggleModal}
        />
      )}

      <CourseCardWithModal
        courseData={courseWithType}
        redirectData={
          isPaid ? { ...course, price: Link?.price || 0 } : courseWithType
        }
        modalOpen={modalOpen}
        toggleModal={toggleModal}
        setModalOpen={setModalOpen}
        isLoggedIn={true}
      />
    </div>
  );
};

export default DashSpStudyNotes;
